import colombiaData from "colombia-cities/colombia_completa.json";

type Municipio = { nombre: string; codigo: string };
type Departamento = { nombre: string; codigo: string; municipios: Municipio[] };

const data = colombiaData as { departamentos: Departamento[] };

const comunasPorMunicipio: Record<string, string[]> = {
  "medellin": Array.from({ length: 16 }, (_, i) => `Comuna ${i + 1}`),
  "cali": Array.from({ length: 22 }, (_, i) => `Comuna ${i + 1}`),
  "barranquilla": Array.from({ length: 7 }, (_, i) => `Comuna ${i + 1}`),
  "bucaramanga": Array.from({ length: 17 }, (_, i) => `Comuna ${i + 1}`),
  "cartagena de indias": Array.from({ length: 15 }, (_, i) => `Comuna ${i + 1}`),
  "bogota, d.c.": Array.from({ length: 20 }, (_, i) => `Localidad ${i + 1}`),
  "bogota d.c.": Array.from({ length: 20 }, (_, i) => `Localidad ${i + 1}`),
  "bogota": Array.from({ length: 20 }, (_, i) => `Localidad ${i + 1}`),
};

export const getDepartamentos = (): string[] =>
  data.departamentos
    .map((d) => d.nombre)
    .sort((a, b) => a.localeCompare(b, "es"));

export const getMunicipiosByDepartamento = (departamento: string): string[] => {
  const depto = data.departamentos.find((d) => d.nombre === departamento);
  if (!depto) return [];
  return depto.municipios
    .map((m) => m.nombre)
    .sort((a, b) => a.localeCompare(b, "es"));
};

export const getComunasByMunicipio = (municipio: string): string[] => {
  const key = municipio.trim().toLowerCase();
  if (comunasPorMunicipio[key]) return comunasPorMunicipio[key];
  return Array.from({ length: 20 }, (_, i) => `Comuna ${i + 1}`);
};

